var map = {
	"./legend_xa.png": 5137,
	"./legend_xa_dark.png": 23610,
	"./legend_xa_dark_vertical.png": 81561,
	"./legend_xa_english.png": 4707,
	"./legend_xa_english_dark.png": 24729,
	"./legend_xa_english_dark_vertical.png": 78996,
	"./legend_xa_english_vertical.png": 26979,
	"./legend_xa_spanish.png": 53680,
	"./legend_xa_spanish_dark.png": 3865,
	"./legend_xa_spanish_dark_vertical.png": 95892,
	"./legend_xa_spanish_vertical.png": 94819,
	"./legend_xa_vertical.png": 28844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9340;